<template>
  <div>
    <base-modal
      :showing="visible"
      @close="onClose"
      size="max-w-lg"
      @opened="onOpened"
    >
      <base-card title="Pilih Alamat Pengiriman" :with-style="false">
        <div class="space-y-4">
          <base-input
            inset
            label="Nama Penerima"
            type="text"
            placeholder="Nama Penerima"
            v-model="form.name"
          />
          <base-input
            inset
            label="No Telp Penerima"
            type="text"
            placeholder="No Telp Penerima"
            v-model="form.phone"
          />

          <base-input inset label="Provinsi">
            <base-select
              inset
              expand
              :options="provinceOptions"
              v-model="form.province"
              @change="onChangeProvince"
            ></base-select>
          </base-input>
          <base-input inset label="Kabupaten">
            <base-select
              inset
              expand
              :options="cityOptions"
              v-model="form.city"
              @change="onChangeCity"
            ></base-select>
          </base-input>
          <base-input inset label="Kecamatan">
            <base-select
              inset
              expand
              :options="districtOptions"
              v-model="form.district"
              @change="onChangeDistrict"
            ></base-select>
          </base-input>
          <base-input inset label="Desa">
            <base-select
              inset
              expand
              :options="villageOptions"
              v-model="form.village"
            ></base-select>
          </base-input>
          <base-input
            inset
            label="Alamat"
            tag="textarea"
            placeholder="Alamat Lengkap"
            v-model="form.address"
          />
          <base-button fullwidth @click="onSave">Gunakan Alamat</base-button>
        </div>
      </base-card>
    </base-modal>
    <loading v-if="loading" />
  </div>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import BaseModal from '@/components/base/BaseModal';

export default {
  components: { BaseModal },
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    officeId: String,
  },
  emits: ['close', 'input', 'change'],
  data() {
    return {
      loading: false,
      form: {
        name: null,
        phone: null,
        province: {
          id: null,
          name: null,
        },
        city: {
          id: null,
          name: null,
        },
        district: {
          id: null,
          name: null,
        },
        village: {
          id: null,
          name: null,
        },
        address: null,
        area: {
          id: null,
          code: null,
        },
      },
      provinces: {
        data: [],
      },
      cities: {
        data: [],
      },
      districts: {
        data: [],
      },
      villages: {
        data: [],
      },
    };
  },
  computed: {
    provinceOptions() {
      return [
        {
          key: 'null',
          label: 'Pilih Provinsi',
          value: {
            id: null,
            name: null,
          },
        },
        ...this.provinces.data.map((province) => ({
          key: province.id,
          label: province.attributes.name,
          value: {
            id: province.id,
            name: province.attributes.name,
          },
        })),
      ];
    },
    cityOptions() {
      return [
        {
          key: 'null',
          label: 'Pilih Kabupaten',
          value: {
            id: null,
            name: null,
          },
        },
        ...this.cities.data.map((city) => ({
          key: city.id,
          label: city.attributes.name,
          value: {
            id: city.id,
            name: city.attributes.name,
          },
        })),
      ];
    },
    districtOptions() {
      return [
        {
          key: 'null',
          label: 'Pilih Kecamatan',
          value: {
            id: null,
            name: null,
          },
        },
        ...this.districts.data.map((district) => ({
          key: district.id,
          label: district.attributes.name,
          value: {
            id: district.id,
            name: district.attributes.name,
          },
        })),
      ];
    },
    villageOptions() {
      return [
        {
          key: 'null',
          label: 'Pilih Desa',
          value: {
            id: null,
            name: null,
          },
        },
        ...this.villages.data.map((village) => ({
          key: village.id,
          label: village.attributes.name,
          value: {
            id: village.id,
            name: village.attributes.name,
          },
        })),
      ];
    },
  },
  methods: {
    async loadProvinces() {
      const [res, err] = await this.request('/api/v1/provinces', {
        params: {
          sort: 'name'
        }
      });

      if (!err) {
        this.provinces = res;
      }
    },
    async loadCities() {
      const [res, err] = await this.request(
        `/api/v1/provinces/${this.form.province.id}/cities`,
        {
          params: {
            include: 'area',
            sort: 'name'
          },
        }
      );

      if (!err) {
        this.cities = res;
      }
    },
    async loadDistricts() {
      const [res, err] = await this.request(
        `/api/v1/cities/${this.form.city.id}/districts`, {
          params: {
            sort: 'name'
          }
        }
      );

      if (!err) {
        this.districts = res;
      }
    },
    async loadVillages() {
      const [res, err] = await this.request(
        `/api/v1/districts/${this.form.district.id}/villages`, {
          params: {
            sort: 'name'
          }
        }
      );

      if (!err) {
        this.villages = res;
      }
    },
    onChangeProvince() {
      this.form.city.id = null;
      this.form.city.name = null;

      this.form.district.id = null;
      this.form.district.name = null;

      this.form.village.id = null;
      this.form.village.name = null;

      this.form.area.code = null;
      this.form.area.id = null;

      this.loadCities();
    },
    onChangeCity() {
      const city = this.cities.data.find(
        (city) => city.id === this.form.city.id
      );
      const area = this.getSingleIncluded(
        this.cities,
        city.relationships.area.data.id
      );

      this.form.area.code = area.attributes.code;
      this.form.area.id = area.id;

      this.form.district.id = null;
      this.form.district.name = null;

      this.form.village.id = null;
      this.form.village.name = null;

      this.loadDistricts();
    },
    onChangeDistrict() {
      this.form.village.id = null;
      this.form.village.name = null;

      this.loadVillages();
    },
    onClose() {
      this.$emit('close');
    },
    onOpened() {
      this.form.name = null;
      this.form.phone = null;

      this.form.province.id = null;
      this.form.province.name = null;

      this.form.city.id = null;
      this.form.city.name = null;

      this.form.district.id = null;
      this.form.district.name = null;

      this.form.village.id = null;
      this.form.village.name = null;

      this.form.address = null;

      this.form.area.id = null;
      this.form.area.code = null;
    },
    async onSave() {
      this.loading = true;

      const [res, err] = await this.request(`/api/v1/addresses`, {
        method: 'post',
        data: {
          data: {
            type: 'addresses',
            attributes: {
              name: this.form.name,
              phone: this.form.phone,
              detail: this.form.address,
            },
            relationships: {
              office: {
                data: {
                  type: 'offices',
                  id: this.officeId,
                },
              },
              province: {
                data: {
                  type: 'provinces',
                  id: this.form.province.id,
                },
              },
              city: {
                data: {
                  type: 'cities',
                  id: this.form.city.id,
                },
              },
              district: {
                data: {
                  type: 'districts',
                  id: this.form.district.id,
                },
              },
              village: {
                data: {
                  type: 'villages',
                  id: this.form.village.id,
                },
              },
            },
          },
        },
      });

      if (!err) {
        this.$emit('change', res);
        this.$emit('close');
      }

      this.loading = false;
    },
  },
  created() {
    this.loadProvinces();
  },
};
</script>
